import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = "Music Grapher - Visualize Your Music Network",
    description = "Create interactive graphs of your favorite musicians from Last.fm. Discover musical connections and explore artist similarities through beautiful data visualization.",
    url,
    image = "/music-graph-preview.png",
    type = "website",
    username = null
}) => {
    const siteTitle = "Musician Grapher";
    const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;

    // Safe way to get current URL
    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://musicgrapher.com');

    // Dynamic description based on username
    const dynamicDescription = username
        ? `Explore ${username}'s music taste through an interactive network graph. Discover connections between artists from Last.fm listening history.`
        : description;

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": siteTitle,
        "description": dynamicDescription,
        "url": currentUrl, // Use the safe URL here
        "applicationCategory": "MultimediaApplication",
        "operatingSystem": "Web Browser",
        "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
        },
        "creator": {
            "@type": "Person",
            "name": "PimvH"
        },
        "keywords": [
            "music visualization",
            "last.fm",
            "artist network",
            "music discovery",
            "data visualization",
            "musician graph",
            "music analytics"
        ]
    };

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={dynamicDescription} />
            <meta name="keywords" content="music visualization, last.fm, artist network, music discovery, data visualization, musician graph, music analytics, similar artists" />
            <meta name="author" content="PimvH" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={currentUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={dynamicDescription} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:site_name" content={siteTitle} />
            <meta property="og:locale" content="en_US" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={dynamicDescription} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:creator" content="@PimvH" />

            {/* Additional Meta Tags */}
            <meta name="theme-color" content="#6c00a2" />
            <meta name="msapplication-TileColor" content="#6c00a2" />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>

            {/* Preconnects for performance */}
            <link rel="preconnect" href="https://ws.audioscrobbler.com" />
        </Helmet>
    );
};

export default SEO;